import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { PermissionsService } from '@core/services/permissions.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PermissionsLoaderGuard  {
    constructor(public router: Router, private permissionsService: PermissionsService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.permissionsService.getUserPermissions().pipe(
            map(userPermissions => {
                this.permissionsService.changeUserPermissions(userPermissions);
                return true;
            }),
            catchError(error => {
                return of(false);
            })
        );
    }
}
